import LwtApi, { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { getSessionId, Header } from '@lwtears/lwt-common-frontend/lib/@common';
import store from '../store';
import { setActivityTimestamp } from 'store/actions/ui';
import { getLocale } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const getEventContext = module => {
  if (!module) return null;

  const {
    ui: { appMode }
  } = store.getState();
  if (appMode === 'tester') return { appMode };

  const {
    activity: {
      data: { sequenceId, level, character: { character, characterCase, characterType } = {} },
      activities,
      currentRoundIndex
    },
    student: { classroom, characterOrder, freePlay }
  } = store.getState();

  const { sequenceActivityId, activityId, activityTemplateId, type: activityType } =
    activities[currentRoundIndex] || {};

  return {
    module,
    sessionId: getSessionId(),
    classroomId: classroom.id,
    characterOrder,
    freePlay,
    sequenceId,
    sequenceActivityId,
    character: { character, characterCase, characterType },
    level,
    activityId,
    activityTemplateId,
    activityType
  };
};

const onRequestDone = () => {
  if (getSessionId()) store.dispatch(setActivityTimestamp());
};

const addHeaders = () => ({ [Header.LOCALE]: getLocale() });

const addErrorLogMetadata = props => {
  const { context: ctx } = props;
  const context = getEventContext(ctx && ctx.module);

  return { ...(context && { context }) };
};

const sanitizeUrl = ({ url, module, ...options }) => {
  const sanitizedUrl = module ? `/${module}${url}` : url;

  return { url: sanitizedUrl, ...options };
};

const setContext = options => ({ ...(options.module && { module: options.module }) });

export const createEvent = (type, { module, ...data }) => {
  const {
    ui: { isLiteVersion }
  } = store.getState();

  if (isLiteVersion) return;

  Api.createTelemetryEvent({ payload: { type, data: { ...data, ...getEventContext(module) } } });
};

const Api = LwtApi()
  .addDefaultAuthStrategy(AuthStrategy.SESSION)
  .addRequestContext(setContext)
  .addRequestMiddleware(sanitizeUrl)
  .addHeaders(addHeaders)
  .addErrorLogMetadata(addErrorLogMetadata)
  .onDone(onRequestDone);

export default Api;
